import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import FormCloseButton from '../../../components/Form/FormCloseButton';
import { BLACK, FEED_BACK, PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { ROUTE_CONSTANTS } from '../../app/RouteBuilding/routeConstants';

const rootSx = {
  alignItems: 'center',
  borderBottom: `1px solid ${BLACK[30]}`,
  display: 'flex',
  gap: '24px',
  justifyContent: 'space-between',
  padding: '16px 24px',
};

const leftSx = { alignItems: 'center', display: 'flex', gap: '24px', minWidth: 0 };

const titleBlockSx = { minWidth: 0 };

const titleRowSx = { alignItems: 'center', display: 'flex', gap: '12px' };

const titleSx = { color: BLACK[100], fontFamily: PRIMARY_FONT[700], fontSize: '20px' };

const approvalChipSx = {
  backgroundColor: BLACK[30],
  borderRadius: '12px',
  color: BLACK[80],
  fontFamily: PRIMARY_FONT[500],
  fontSize: '12px',
  padding: '2px 10px',
  whiteSpace: 'nowrap',
};

const approvedChipSx = { ...approvalChipSx, backgroundColor: FEED_BACK.GREEN_80, color: BLACK[0] };

const corporationSx = { color: BLACK[70], fontSize: '13px' };

const goToJobsButtonSx = {
  borderColor: PRIMARY_PURPLE[70],
  borderRadius: '6px',
  color: PRIMARY_PURPLE[70],
  fontFamily: PRIMARY_FONT[500],
  textTransform: 'none',
  whiteSpace: 'nowrap',
};

const PositionTemplateDetailHeader = ({ positionTemplate }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const isApproved = !!positionTemplate.approved;

  const goToJobs = () => {
    const params = new URLSearchParams({
      corporation: positionTemplate.corporation?._id || '',
      position: positionTemplate.name || '',
    });
    navigate(`/${ROUTE_CONSTANTS.JOB_ORDERS}?${params.toString()}`);
  };

  return (
    <Box sx={rootSx}>
      <Box sx={leftSx}>
        <FormCloseButton
          onClose={() => navigate(`/${ROUTE_CONSTANTS.POSITION_TEMPLATES}`)}
          message="buttonText.goBack"
        />
        <Box sx={titleBlockSx}>
          <Box sx={titleRowSx}>
            <Typography component="h1" sx={titleSx}>
              {positionTemplate.name}
            </Typography>
            <Box
              data-testid="pt-detail-approval-chip"
              sx={isApproved ? approvedChipSx : approvalChipSx}
            >
              {intl.formatMessage({
                id: isApproved ? 'pt.detail.status.approved' : 'pt.detail.status.notApproved',
              })}
            </Box>
          </Box>
          <Typography sx={corporationSx}>{positionTemplate.corporation?.name}</Typography>
        </Box>
      </Box>
      <Button variant="outlined" onClick={goToJobs} sx={goToJobsButtonSx}>
        {intl.formatMessage({ id: 'buttonText.goToJobs' })}
      </Button>
    </Box>
  );
};

PositionTemplateDetailHeader.propTypes = {
  positionTemplate: PropTypes.shape({
    approved: PropTypes.bool,
    corporation: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
    name: PropTypes.string,
  }).isRequired,
};

export default PositionTemplateDetailHeader;
